import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const WalletCard = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M 42.1875 24.480469 L 37.707031 24.480469 C 36.667969 24.480469 35.550781 24.953125 34.757812 25.605469 L 34.4375 25.898438 C 34.402344 25.933594 34.363281 25.96875 34.320312 26 L 32.0625 27.847656 C 28.148438 31.683594 22.078125 31.6875 18.15625 27.859375 L 15.886719 26 L 15.675781 25.792969 C 14.992188 24.976562 13.8125 24.480469 12.5 24.480469 L 7.8125 24.480469 L 7.8125 39.582031 C 7.8125 41.023438 8.976562 42.1875 10.417969 42.1875 L 39.582031 42.1875 C 41.023438 42.1875 42.1875 41.023438 42.1875 39.582031 Z M 10.160156 16.15625 C 9.5625 16.21875 9.003906 16.480469 8.574219 16.910156 C 8.085938 17.398438 7.8125 18.058594 7.8125 18.75 L 7.8125 21.355469 L 12.5 21.355469 C 14.460938 21.355469 16.546875 22.066406 17.949219 23.652344 L 20.15625 25.457031 L 20.273438 25.5625 C 22.996094 28.285156 27.214844 28.285156 29.9375 25.5625 L 30.050781 25.457031 L 32.304688 23.613281 C 33.597656 22.359375 35.605469 21.355469 37.707031 21.355469 L 42.1875 21.355469 L 42.1875 18.75 C 42.1875 18.058594 41.914062 17.398438 41.425781 16.910156 C 40.996094 16.480469 40.4375 16.21875 39.839844 16.15625 L 39.582031 16.144531 L 10.417969 16.144531 Z M 42.1875 10.417969 C 42.1875 8.976562 41.023438 7.8125 39.582031 7.8125 L 10.417969 7.8125 C 8.976562 7.8125 7.8125 8.976562 7.8125 10.417969 L 7.8125 13.652344 C 8.613281 13.242188 9.503906 13.019531 10.417969 13.019531 L 39.582031 13.019531 C 40.496094 13.019531 41.386719 13.242188 42.1875 13.652344 Z M 45.3125 39.582031 C 45.3125 42.746094 42.746094 45.3125 39.582031 45.3125 L 10.417969 45.3125 C 7.253906 45.3125 4.6875 42.746094 4.6875 39.582031 L 4.6875 10.417969 C 4.6875 7.253906 7.253906 4.6875 10.417969 4.6875 L 39.582031 4.6875 C 42.746094 4.6875 45.3125 7.253906 45.3125 10.417969 Z M 45.3125 39.582031 "
        fill={color}
      />
    </svg>
  )
}
